var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      placeholder: _vm.placeholder,
      noOptionsText: "Nothing matches the query",
      pillsColor: _vm.pillsColor,
      customMultiStyleParent: _vm.computedCustomStyles,
      value: _vm.chosenSkills,
      options: _vm.skillsOptions,
      loading: _vm.$apollo.queries.skills.loading,
      disabled: _vm.disabled,
      max: _vm.max,
    },
    on: { search: _vm.updateSearch, input: _vm.handleInput },
    scopedSlots: _vm._u(
      [
        {
          key: "noRii",
          fn: function () {
            return [
              _vm._t("noResult", null, {
                currentSearchString: _vm.skillSearchString,
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "option",
          fn: function ({ option }) {
            return [
              _vm._t("option", null, {
                option: option,
                newSkill: _vm.isNewSkill(option),
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }